import { createStore, createEvent } from 'effector'

interface State {
  showError: boolean
}

const initial: State = {
  showError: false,
}

export const changeError$ = createEvent<boolean>()

export const pickerStore = createStore(initial).on(
  changeError$,
  (state, showError) => ({ ...state, showError })
)
